export default __webpack_public_path__ + "static/media/esocial_logo.7b6d67f1.png";